import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Link as MuiLink,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { store } from '../../config/firebase';
import GameByStatusCards from '../ui/gameStatusCards/gameByStatusCards';
import { getGameBySectionId } from '../../features/game/gameSlice';
import { useAuth } from '../../contexts/authContext';

const Section = () => {
  const dispatch = useDispatch();
  const { currentUserProfile } = useAuth();
  const { eventId, sectionId } = useParams();
  const [section, setSection] = useState();
  const [event, setEvent] = useState();
  const [loading, setLoading] = useState();

  const sectionGames = useSelector((state) => state.game.games);

  const [filterRounds, setFilterRound] = useState('');
  const [filteredGames, setFilteredGames] = useState(sectionGames);

  useEffect(() => {
    setLoading(true);
    const docRef = doc(store, 'events', eventId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const eventData = { id: docSnap.id, ...docSnap.data() };
        setEvent(eventData);
      } else {
        console.log('No such document!');
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [eventId]);

  useEffect(() => {
    if (event && event.sections && event.sections.length > 0) {
      const section = event.sections.find((section) => section.id === sectionId);
      setSection(section);

      dispatch(getGameBySectionId(sectionId));
    }
  }, [event, sectionId]);

  useEffect(() => {
    if (filteredGames.length === 0) {
      setFilteredGames(sectionGames);
    }
  }, [sectionGames]);

  useEffect(() => {
    let _fgames = sectionGames;

    if (filterRounds !== '') {
      _fgames = _fgames.filter((g) => g.round === filterRounds);
    }

    setFilteredGames(_fgames);
  }, [filterRounds, sectionGames]);

  const clearFilters = () => {
    setFilterRound('');
    setFilteredGames(sectionGames);
  };

  return section ? (
    <Box>
      <Link to={`/events/${eventId}`} style={{ textDecoration: 'none' }}>
        <MuiLink color="primary" underline="hover">
          {event.name}
        </MuiLink>
      </Link>
      <Typography variant="h4" gutterBottom>
        {section.name}
      </Typography>

      <Box display={'flex'} alignItems={'center'} gap={2} flexWrap={'wrap'}>
        <FormControl sx={{ width: 200, my: 2 }}>
          <InputLabel id={'filterRoundsLabel'}>Filter Rounds</InputLabel>
          <Select
            labelId="filterRoundsLabel"
            value={filterRounds}
            onChange={(event) => setFilterRound(event.target.value)}>
            <MenuItem value={''}>None</MenuItem>
            {(() => {
              let container = [];
              for (let i = 0; i < event.gameFormat.rounds; i++) {
                container.push(
                  <MenuItem key={i} value={i + 1}>
                    Round {i + 1}
                  </MenuItem>
                );
              }
              return container;
            })()}
          </Select>
        </FormControl>
        <Button size="small" variant="text" color="primary" onClick={clearFilters}>
          Clear
        </Button>
      </Box>
      <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'} gap={2}>
        {filteredGames && filteredGames.length > 0 ? (
          filteredGames.map((game, index) => <GameByStatusCards game={game} key={index} />)
        ) : (
          <Typography>No Games</Typography>
        )}
      </Box>
    </Box>
  ) : (
    <CircularProgress />
  );
};

export default Section;
